import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Equipment} from "../../../models/equipment";
import {Skill, SkillLevel} from "../../../models/skill";
import {SkillManagerService} from "../../../services/skill-manager.service";
import {Paginator} from "../../../models/paginator";
import {Utils} from "../../../utils";

export interface BindSkillDialogData {
  isNew: boolean;
  skillId: string;
  skillLevelId: string;
  skill: Skill;
  skillLevel: SkillLevel;
  assignedSkills: Skill[];
}

@Component({
  selector: 'app-bind-skill-dialog',
  templateUrl: './bind-skill-dialog.component.html',
  styleUrls: ['./bind-skill-dialog.component.scss']
})
export class BindSkillDialogComponent implements OnInit {

  isLoading: boolean;

  /* Search skill */
  skillFilter: string;
  filteredSkills: Skill[];
  skills: Skill[];

  /* Search skill levels */
  skillLevelFilter: string;
  filteredSkillLevels: SkillLevel[];
  skillLevels: SkillLevel[];

  constructor(
    public dialogRef: MatDialogRef<BindSkillDialogComponent>,
    private skillManagerService: SkillManagerService,
    @Inject(MAT_DIALOG_DATA) public data: BindSkillDialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    await Promise.all([
      this.fetchSkills(),
      this.fetchSkillLevels(),
    ]);
    this.isLoading = false;
  }

  async fetchSkills() {
    this.skills = await this.skillManagerService.getAllSkills(new Paginator<Skill>({ignorePagination: true}));

    // Remove assigned skills for new binding
    if (this.data.isNew) {
      this.skills = this.skills.filter(skill => !this.data.assignedSkills.map(_skill => _skill.id).includes(skill.id));
    }

    this.filteredSkills = this.skills;
  }

  async fetchSkillLevels() {
    this.skillLevels = await this.skillManagerService.getAllSkillLevels(new Paginator<SkillLevel>({ignorePagination: true}));
    this.filteredSkillLevels = this.skillLevels;
  }

  validate() {
    return !Utils.isEmpty(this.data.skillId) && !Utils.isEmpty(this.data.skillLevelId);
  }

  get finalData(): BindSkillDialogData {
    return { ...this.data, skill: this.skills.find(skill => skill.id === this.data.skillId), skillLevel: this.skillLevels.find(skillLevel => skillLevel.id === this.data.skillLevelId) };
  }

}
